<div
  class="meeting-calendar-event"
  [class.meeting-accent]="meeting.type?.key === MEETING_TYPE_EXAM && MEETING_TYPE_EXAM"
  [class.meeting-primary]="meeting.type?.key === MEETING_TYPE_IDD_TRAINING"
  [class.meeting-warm]="meeting.type?.key === MEETING_TYPE_NEW_AGENT_TRAINING"
  [routerLink]="['/egzaminy-szkolenia/szczegoly', meeting.uuid]"
  [matTooltip]="tooltipText"
  matTooltipClass="break-line-tooltip"
  matTooltipPosition="above"
>
  <div fxLayout="column">
    <div fxLayout="row">
      [{{meeting.startsAt | date:'HH:mm'}}]
      <ng-container *ngIf="meeting.insuranceCompany">
        {{meeting.insuranceCompany.name}}<ng-container *ngIf="meeting.examType">, {{meeting.examType.name}}</ng-container>
      </ng-container>
      <ng-container *ngIf="!meeting.insuranceCompany">
        {{meeting.leader?.name}}
      </ng-container>
    </div>

    <div fxLayout="row" *ngIf="meeting.address || meeting.insuranceCompany?.imageLocation || meeting.link">
      <ng-container *ngIf="meeting.insuranceCompany?.imageLocation">
        <img src="/rest/crm/insuranceCompany/{{meeting.insuranceCompany?.id}}/image" alt="Zdjęcie" height="20"/>
      </ng-container>
      <ng-container *ngIf="meeting.address">
        <span fxFlex></span>
        <span class="bottom-right-text">
          <mat-icon>place</mat-icon> {{meeting.address.city}}
        </span>
      </ng-container>
      <ng-container *ngIf="!meeting.address">
        <span fxFlex></span>
        <span class="bottom-right-text">
          <mat-icon>language</mat-icon> {{meeting.place.name}}
        </span>
      </ng-container>
    </div>
  </div>
</div>
